import loadable from "@loadable/component";

export const CombinedPaymentPage = loadable(
  () => import("./CombinedPaymentPage"),
  {
    resolveComponent: mod => mod.CombinedPaymentPage,
  },
);

export * from "./types";
